module.exports = __webpack_public_path__ + "static/media/strike.894fa201.png";